
import { Download } from "@mui/icons-material";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { useRifaStore } from "../../store/rifaStore";
import Modal from "../Modal";
import ModalCustom from "../ModalCustom";
import useWindowSize from "../../hooks/sizeWindow";
import { Alert } from "react-bootstrap";
import { sendRespuesta } from "../../screens/Rifa/handler";
import Loading from "../Loading";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import InputRHF from "../InputRHF";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { reenviarEmail } from "./handlers";

const ModalReenviarEmail = () => {

    const [loading, setLoading] = useState(false);
    const [loadingReenviar, setLoadingReenviar] = useState(false);

    // const datos = getValues();
    // console.log(datos)
    const { modals, handlerModal, loads } = useGeneralAppStore()
    const { solicitud } = useRifaStore();
    const size = useWindowSize();
    let { width, height } = size;
    // console.log(size)

    const schema = yup.object({
        email: yup.string().email('Email invalido').required('Email requerido')
    })

    const {
        register,
        watch,
        setError,
        formState: { errors },
        handleSubmit,

    } = useForm({
        defaultValues: {

        },
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        await reenviarEmail(data, setError);
    }


    return (
        <>
            <ModalCustom
                show={modals.includes('reenviar-email')}
                size={"md"}
                padding={0}
                onHide={() => { handlerModal({ modal: false, modalName: "reenviar-email" }) }}
                title={() => "Reenviar email"}
                bg={"#E2CFF4"}
                bgHeader={"#1976D2"}
                colorHeader={"#fff"}
            >
                <form onSubmit={handleSubmit(onSubmit)} className="position-relative">
                    {
                        loads.includes('reenviar-email') &&
                        <div className="position-absolute w-100 h-100 " style={{ background: "rgba(1,1,1,0.8)", zIndex: "99999" }}>
                            <Loading time={100} variant={2} />
                        </div>
                    }
                    <section style={{ color: "#742ABE" }} className="bgModal py-4 px-3 position-relative">
                        <p className="text-center" style={{ fontSize: "14px" }}>Ingrese un correo electronico para reenviar el email</p>
                        <label htmlFor="email" className="w-100 pt-3 " style={{ fontSize: "14px", color: "#742ABE" }}>EMAIL</label>
                        <InputRHF className={` ${width <= "430" ? "col-12" : "col-12"} `} id={"email"} /* label={'EMAIL'} */ argentino={watch('is_argentino')} campo={'email'} type="email" register={register} errors={errors} placeholder={'EMAIl . . .'} />
                        <button onClick={() => {
                        }} className="py-1 px-4 mt-5 text-white" style={{ fontSize: "1rem", boxShadow: "none", border: "none" }}>REENVIAR</button>
                    </section>
                </form>
            </ModalCustom>
        </>
    );
}
export default ModalReenviarEmail;